(function () {
  function cleanText(value) {
    return (value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function extractMoney(value) {
    var text = cleanText(value);
    var match = text.match(/(?:\d{1,3}(?:[ .]\d{3})*|\d+)(?:[,.]\d{1,2})?\s*(?:€|EUR)/i);
    return match ? cleanText(match[0]).replace(/EUR/i, '€') : '';
  }

  function isVisible(node) {
    if (!node) return false;
    var style = window.getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function initMobileAtc() {
    if (!document.body.classList.contains('template-product')) return;
    if (window.manuzenTheme && window.manuzenTheme.mobileAtc === false) return;

    var original = document.querySelector('product-form .product-form__submit, .product-form__submit');
    if (!original || document.querySelector('.mz-mobile-atc')) return;

    var sourceForm = original.closest('form');
    var cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';

    function getProductTitle() {
      var title = document.querySelector('.product__title h1, .product__title h2, h1.product__title, .product__info-container h1, main h1');
      var value = title ? cleanText(title.textContent) : '';
      return value || cleanText(document.title.split('|')[0]) || 'Votre produit';
    }

    function getCurrentPrice() {
      var selectors = [
        '.product__info-container .price__sale .price-item--sale',
        '.product__info-container .price__regular .price-item--regular',
        '.product__info-container [data-product-price]',
        '.product__info-container .price-item--sale',
        '.product__info-container .price-item--regular',
        '.product__info-container .price'
      ];

      for (var i = 0; i < selectors.length; i += 1) {
        var nodes = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < nodes.length; j += 1) {
          if (!isVisible(nodes[j])) continue;
          var amount = extractMoney(nodes[j].innerText || nodes[j].textContent);
          if (amount) return amount;
        }
      }

      return '';
    }

    var bar = document.createElement('div');
    bar.className = 'mz-mobile-atc';
    bar.setAttribute('aria-label', 'Achat rapide');
    bar.innerHTML =
      '<div class="mz-mobile-atc__summary">' +
        '<small>Votre sélection</small>' +
        '<div class="mz-mobile-atc__title"></div>' +
        '<div class="mz-mobile-atc__price" aria-live="polite"></div>' +
      '</div>' +
      '<a class="mz-mobile-atc__action" href="#">Ajouter au panier</a>';

    var titleNode = bar.querySelector('.mz-mobile-atc__title');
    var priceNode = bar.querySelector('.mz-mobile-atc__price');
    var action = bar.querySelector('.mz-mobile-atc__action');

    function updateBar() {
      titleNode.textContent = getProductTitle();
      var price = getCurrentPrice();
      priceNode.textContent = price || 'Prix affiché sur la fiche';
      var variantInput = sourceForm ? sourceForm.querySelector('[name="id"]') : null;
      var variantId = variantInput ? variantInput.value : '';
      var unavailable = !!original.disabled || !variantId;
      action.classList.toggle('is-disabled', unavailable);
      action.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      action.textContent = unavailable ? 'Indisponible' : 'Ajouter au panier';
      action.href = unavailable
        ? '#'
        : cartAddUrl + '?id=' + encodeURIComponent(variantId) + '&quantity=1&return_to=' + encodeURIComponent(cartUrl);
    }

    document.body.appendChild(bar);
    updateBar();

    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0.15 });
    observer.observe(original);

    var info = document.querySelector('.product__info-container');
    if (info) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        window.setTimeout(function () {
          updateBar();
          queued = false;
        }, 80);
      }).observe(info, { childList: true, subtree: true, characterData: true, attributes: true });
    }

    document.addEventListener('variant:change', updateBar);
    document.addEventListener('change', function (event) {
      if (event.target.closest('variant-selects, variant-radios, .product-form__input')) {
        window.setTimeout(updateBar, 80);
      }
    });
  }

  function initMobileCartCheckout() {
    if (!document.body.classList.contains('template-cart')) return;

    var checkout = document.querySelector('#checkout, button[name="checkout"]');
    if (!checkout || document.querySelector('.mz-mobile-cart-checkout')) return;

    var bar = document.createElement('div');
    bar.className = 'mz-mobile-cart-checkout';
    bar.setAttribute('aria-label', 'Accès rapide au paiement');
    bar.innerHTML =
      '<div class="mz-mobile-cart-checkout__summary">' +
        '<small>Total de la commande</small>' +
        '<strong aria-live="polite"></strong>' +
      '</div>' +
      '<button type="button">Passer au paiement</button>';

    var totalNode = bar.querySelector('strong');
    var action = bar.querySelector('button');

    function currentTotal() {
      var nodes = document.querySelectorAll('.totals__total-value, .cart__footer .price, #main-cart-footer .price');
      for (var i = 0; i < nodes.length; i += 1) {
        if (!isVisible(nodes[i])) continue;
        var amount = extractMoney(nodes[i].innerText || nodes[i].textContent);
        if (amount) return amount;
      }
      return '';
    }

    function updateBar() {
      totalNode.textContent = currentTotal() || 'Voir le total';
      action.disabled = !!checkout.disabled;
    }

    action.addEventListener('click', function () {
      updateBar();
      if (!checkout.disabled) checkout.click();
    });

    document.body.appendChild(bar);
    updateBar();

    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0.1 });
    observer.observe(checkout);

    var cart = document.querySelector('#main-cart-items, #main-cart-footer');
    if (cart) {
      new MutationObserver(function () {
        window.setTimeout(updateBar, 80);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  function init() {
    initMobileAtc();
    initMobileCartCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();